import React from "react";
import { graphql } from "gatsby";
import { split, join, map, capitalize } from "lodash";
import theme from "storybook-styles/theme";
import { FlexContainer } from "storybook-components/Container";
import SEO from "../components/SEO";
import Layout from "../components/Layout";
import Header from "../components/Header";
import HeroContainer from "../components/HeroContainer";
import PostColumnContainer from "../components/PostPreviewSections/PostColumnContainer";
import PostPreview from "../components/PostPreviewCards/PostPreviewHero";
import PostPreviewCard from "../components/PostPreviewCards/PostPreviewCard";
import CategoryEditorPicks from "../components/PostPreviewSections/CategoryEditorPicks";
import Paginator from "../components/Paginator";

const formatCategoryName = category => {
  const splitString = split(category, "-");
  return join(map(splitString, capitalize), " ");
};

const CategoryTemplate = ({ data, pageContext }) => {
  const categorySlug = pageContext.slug;
  const categoryName =
    categorySlug === "general"
      ? "Mode updates"
      : formatCategoryName(categorySlug);
  const { currentPage, numberOfPages } = pageContext;
  const topPost = data.categoryPosts.edges.slice(0, 1)[0];

  return (
    <Layout backgroundColor={theme.colors.green1}>
      <SEO
        title={`${categoryName} · Mode Blog`}
        pathname={`/category/${categorySlug}`}
      />

      <FlexContainer>
        <HeroContainer>
          <div>
            <Header headerText={categoryName} />
            <PostPreview node={topPost.node} />
          </div>
        </HeroContainer>
      </FlexContainer>
      <CategoryEditorPicks
        posts={data.popularPosts}
        categoryName={categoryName}
      />
      <PostColumnContainer>
        {data.categoryPosts.edges.map(edge => (
          <PostPreviewCard key={edge.node.slug} node={edge.node} />
        ))}
      </PostColumnContainer>
      <PostColumnContainer>
        <Paginator
          currentPage={currentPage}
          numberOfPages={numberOfPages}
          pathRoot={`/category/${categorySlug}`}
        />
      </PostColumnContainer>
    </Layout>
  );
};

export const query = graphql`
  query categoryQuery($slug: String!, $skip: Int!, $limit: Int!) {
    categoryPosts: allContentfulBlogPost(
      sort: { fields: [publishDate], order: DESC }
      filter: { categories: { eq: $slug } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          title
          slug
          publishDate
          categories
          heroImage {
            title
            gatsbyImageData(layout: FULL_WIDTH)
          }
          author {
            name
            title
            twitter
            image {
              file {
                url
              }
            }
          }
          openGraphImage {
            file {
              url
            }
          }
          description {
            description
          }
          longDescription {
            childMarkdownRemark {
              html
            }
          }
          body {
            childMarkdownRemark {
              timeToRead
            }
          }
          richTextBody {
            raw
          }
          createdAt
        }
      }
    }
    popularPosts: allContentfulBlogPost(
      limit: 100
      filter: { isPopular: { eq: true }, categories: { eq: $slug } }
    ) {
      edges {
        node {
          title
          slug
          categories
          body {
            childMarkdownRemark {
              timeToRead
            }
          }
          richTextBody {
            raw
          }
        }
      }
    }
  }
`;

export default CategoryTemplate;
